module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/213-gibraltar-c706ddb9f481857d344e41bb6281d4c6.svg";